import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { logger } from '../../../../utils/logger';
import { getOrderId } from '../../selectors/order/get-order-id';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
import { clearOrder } from './clear-order';
/**
 * Cancels an in-progress order and clears the local state.
 */
export const cancelOrder = () => {
    const orderId = getOrderId();
    clearOrder();
    runInAction(() => {
        temporaryOrderDomainStore.reset();
    });
    if (!orderId)
        return;
    // Don't bother awaiting the order cancellation. It'll be automatically cleaned up if this fails anyway.
    ocapiClient.instance.v1.orders.cancel(orderId).catch(() => {
        logger.error(`Failed to cancel order with ID: ${orderId}.`);
    });
};
